import { action, observable, toJS } from "mobx";
import { replaceUrlParam } from "@utils/Browser";
import { distanceBetweenTwoPoints } from "@src/libs/geo";

import rootService from "../@data/service";

const { search } = rootService;

const MAX_SEARCH_DISTANCE = 30; // 50km
const DELAY_SEARCH = 1000; // 50km

class SearchMapMapStore {
	@observable activeMarker = null;
	@observable geoCenter;

	delaySearch = DELAY_SEARCH;
	centerGeoPosition = null;
	geoBoundPosition = {
		topLeft: null,
		bottomRight: null,
	};
	@observable zoom = 10;

	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		// this.lastGeoPosition = staticContext.app.location;
	}

	@action
	setActiveMarker(val) {
		this.activeMarker = val;
	}

	@action
	updateGeoBound(topLeft, bottomRight, center, zoom) {
		const { topLeft: lastTopLeft } = this.geoBoundPosition;
		if (!lastTopLeft) {
			this.geoBoundPosition.topLeft = topLeft;
			console.debug("Nothing to compare.");
			return;
		}

		const distance = distanceBetweenTwoPoints(lastTopLeft, topLeft);
		console.log("distance", distance);
		if (distance > MAX_SEARCH_DISTANCE) {
			console.log("updating geo position...");
			this.centerGeoPosition = center;
			this.zoom = zoom;
			this.geoBoundPosition = {
				topLeft,
				bottomRight,
			};
			this.updateLocation();
		}
	}

	updateLocation() {
		const { history } = this.rootStore;
		const appendToURL = (k, v, url = `/search-map${window.location.search}`) =>
			replaceUrlParam(url, k, v);
		const convertPosToString = (pos) =>
			pos.lat && pos.lng ? `${pos.lat},${pos.lng}` : null;

		const properiesToAppend = {
			center: convertPosToString(this.centerGeoPosition),
			topLeft: convertPosToString(this.geoBoundPosition.topLeft),
			bottomRight: convertPosToString(this.geoBoundPosition.bottomRight),
			zoom: this.zoom,
		};

		let url;
		for (let [k, v] of Object.entries(properiesToAppend)) {
			if (v) {
				url = appendToURL(k, v, url);
			}
		}
		return history.push(url);
	}

	@action
	moreZoom() {
		this.zoom += 1;
	}

	@action
	lessZoom() {
		this.zoom -= 1;
	}
}

export default SearchMapMapStore;
